import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { css } from 'aphrodite/no-important';
import styles from './Dropdown.styles';
import Icon from '../icon/Icon';
import Label from '../label/Label';
import SearchInput from '../../../components/inputs/searchinput/SearchInput';

class Dropdown extends Component {
  state = { isMenuOpen: false, filter: '' };

  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  }

  toggle = () => {
    if (!this.state.isMenuOpen) {
      document.addEventListener('click', this.handleOutsideClick, false);
      this.props.onDropdownOpen && this.props.onDropdownOpen();
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  handleIconClick = () => {
    if (this.props.onIconClick) {
      this.props.onIconClick();
    } else {
      this.toggle();
    }
  };

  close = () => {
    this.setState({ isMenuOpen: false });
    document.removeEventListener('click', this.handleOutsideClick, false);
  };

  onSearch = ({ target }) => {
    this.setState({ filter: target.value });
  };

  handleClick = ({ target }) => {
    let selected = JSON.parse(target.dataset.value);
    this.props.onSelect(selected);
    this.close();
  };

  handleOutsideClick = e => {
    let node = ReactDOM.findDOMNode(this);
    if (e.target instanceof Node && node && !node.contains(e.target)) {
      this.close();
    }
  };

  renderIcon = (customStyles, sortSelected, sortReverse) => {
    const iconStyles = [styles.icon, customStyles && customStyles.icon];
    let iconValue = 'chevron-down';
    if (sortSelected) {
      iconStyles.push(styles.iconBlue);
      if (sortReverse) {
        iconValue = 'chevron-up';
      }
    }
    return (<Icon
      value={iconValue}
      styles={iconStyles}
      onClick={this.handleIconClick}
    />);
  };

  renderHeader = () => {
    let {
      value,
      isCompact,
      showIcon,
      showMenu,
      styles: customStyles,
      sortSelected,
      sortReverse
    } = this.props;
    return (
      <div
        className={css(
          styles.dropdownText,
          showMenu && styles.dropdownWithMenu,
          isCompact && styles.dropdownCompact
        )}
      >
        <span
          className={css(styles.text, isCompact && styles.textCompact)}
          onClick={this.toggle}
        >
          {value}
        </span>
        {showIcon && this.renderIcon(customStyles, sortSelected, sortReverse)}
      </div>
    );
  };

  renderList = () => {
    let { options, showSearch } = this.props;
    let { isMenuOpen } = this.state;
    return (
      <ul className={`${css(styles.ul, isMenuOpen && styles.ulshow)}`}>
        {showSearch && (
          <li className={css(styles.li, styles.search)}>
            <SearchInput onChange={this.onSearch} />
          </li>
        )}
        <div className={css(styles.items, showSearch && styles.itemsSearch)}>
          {options &&
            options
              .filter(option =>
                option.name
                  .toLowerCase()
                  .includes(this.state.filter.toLowerCase())
              )
              .map((option, index) => (
                <li
                  className={css(styles.li)}
                  onClick={this.handleClick}
                  data-value={JSON.stringify(option.value)}
                  key={index}
                >
                  {option.name}
                </li>
              ))}
        </div>
      </ul>
    );
  };

  render() {
    let { label, showMenu, styles: customStyles } = this.props;
    return (
      <div className={css(styles.base, customStyles && customStyles.base)}>
        {label && <Label>{label}</Label>}
        <div className={css(styles.dropdown)}>
          {this.renderHeader()}
          {showMenu && this.renderList()}
        </div>
      </div>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/common/dropdown/Dropdown.js